import React, { Component } from "react";
import FooterEN from "../Symbols/FooterEN";
import "../../stylesheets/Kontakt.css";
import Fer1 from "../../assets/ferrules_2.jpg";
import Fer2 from "../../assets/ferrules_6.jpg";
import Fer3 from "../../assets/ferrules_8.jpg";
import Fer4 from "../../assets/ferrules_5.jpg";
import Fer5 from "../../assets/ferrules_9.jpg";
import Fer6 from "../../assets/ferrules_7.jpg";
import { Helmet } from "react-helmet-async";
import NavEN from "../Symbols/NavEN";

class Ferrules extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Referenzen</title>
          <meta
            name="description"
            content="Entdecken Sie spannende Referenzen von Pancon – innovative
Lösungen, erfolgreich umgesetzte Projekte, zufriedene Kunden, Distributoren.
Lassen Sie sich von unserer Kompetenz und Erfahrung überzeugen!"
          />
          <meta property="og:title" content="Pancon - Referenzen" />
          <meta
            property="og:description"
            content="Entdecken Sie spannende Referenzen von Pancon – innovative
Lösungen, erfolgreich umgesetzte Projekte, zufriedene Kunden, Distributoren.
Lassen Sie sich von unserer Kompetenz und Erfahrung überzeugen!"
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/referenzen"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/references"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavEN />
        <div className="hero ref ferrules">
          <div className="red-bg-hero"></div>
          <div className="hero-content">
            <h1 className="hero-heading">Ferrules</h1>
            <p className="hero-desc">Our portfolio features ferrules in 300 standard sizes, shapes and colours with cross-sections from 0.08 mm² to 240 mm².
              We are also able to provide ferrules with custom dimensions according to your specifications or even plastic parts such as insulating collars based on drawings.</p>
          </div>
        </div>
        <div id="intro" className="section first flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <h2 className="alternate-heading">Ferrules directly from our Distributors in USA</h2>
            </div>
            <p className="body padding-default no-marg">
              For industrial needs, we provide ferrules directly from our distributors in USA.</p>
            <h3 className="alternate-heading ferrules">Shorter delivery times & lower procurement costs</h3>
            <p className="body padding-default as-new ferrules">
            Thanks to local storage at distributors:</p>
            <ul className="body margin-bottom ferrules">
                <li><strong>No long international shipping times</strong> or expensive customs clearance.</li>
                <li><strong>Faster response times</strong> for urgent projects or repeat orders.</li>
                <li><strong>Cut savings</strong> through volume discounts or elimination of import fees.</li>
              </ul>
          </div>
        </div>
        <div
          className="section flex center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2 className="ferrules">Insulated single and twin ferrules
              </h2>
              <ul className="body margin-bottom ferrules">
                <li>Colour ranges&nbsp;1, 2 and&nbsp;DIN</li>
                <li>Dimensional tolerances according to DIN&nbsp;46228-4</li>
                <li>Polypropylene entry funnel</li>
                <li>Heat resistant up to&nbsp;105 °C</li>
                <li>Material: ECu</li>
                <li>Electro-tinned surface — minimum thickness of layer&nbsp;3 µm</li>
                <li>Customized Packaging</li>
              </ul>
              <img className="flex center-h ferrules" src={Fer1}></img>
            </div>
          </div>
        </div>
        <div
          className="section intro flex first center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2 className="ferrules">Insulated ferrules in strips and on reels
              </h2>
              <ul className="body margin-bottom ferrules">
                <li>Specifications as single ferrules; plus:</li>
                <li>Strips in sizes of 500 ferrules (pack 10 × 500)</li>
                <li>Small reels in sizes of 500 – 1 100</li>
                <li>Crimpstar reels in sizes of 2 500 – 4 000</li>
                <li>Medium reels in sizes of 5 000 – 10 000</li>
              </ul>
              <img className="flex center-h ferrules" src={Fer2}></img>
            </div>
          </div>
        </div>
        <div
          className="section intro flex first center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2 className="ferrules">Ferrules for short-circuit-proof & ground-fault-proof cabling
              </h2>
              <ul className="body margin-bottom ferrules">
                <li>Specifications as single ferrules; plus:</li>
                <li>Insulating collar for short-circuit-proof and ground-fault-proof cabling up to 3 kV</li>
                <li>Customized Packaging</li>
              </ul>
              <img className="flex center-h ferrules" src={Fer3}></img>
            </div>
          </div>
        </div>
        <div
          className="section intro flex first center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2 className="ferrules">Uninsulated ferrules
              </h2>
              <ul className="body margin-bottom ferrules">
                <li>Dimensional tolerances according to DIN 46228-1</li>
                <li>Material: ECu</li>
                <li>Electro-tinned surface — minimum thickness of layer 3 µm</li>
                <li>Packaged in batch sizes of 25 to 1000</li>
              </ul>
              <img className="flex center-h ferrules" src={Fer4}></img>
            </div>
          </div>
        </div>
        <div
          className="section intro flex first center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2 className="ferrules">Ferrules in assortment boxes
              </h2>
              <ul className="body margin-bottom ferrules">
                <li>Assortments of insulated and uninsulated ferrules in high-quality dispenser boxes</li>
                <li>Can bottoms also available in coloured versions</li>
              </ul>
              <img className="flex center-h ferrules" src={Fer5}></img>
            </div>
          </div>
        </div>
        <div
          className="section intro flex first center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2 className="ferrules">Tools
              </h2>
              <ul className="body margin-bottom ferrules">
                <li>Tools to use with ferrules</li>
                <li>Ergonomic stripping and crimping tools for solid and flexible conductors</li>
                <li>Different crimping needs: trapezoidal or square crimping</li>
              </ul>
              <img className="flex center-h ferrules" src={Fer6}></img>
            </div>
          </div>
        </div>
        <FooterEN />
      </div>
    );
  }
}

export default Ferrules;
